// @ts-nocheck
import Button from '@rio-cloud/rio-uikit/Button';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { hasInspections } from '@/selectors';

import StartPanelCard from './startpage/StartPanelCard';
import StartTopPanel from './startpage/StartTopPanel';

export const renderViewOnPlayStoreButton = () => (
    <Button
        as='a'
        href='https://play.google.com/store/apps/details?id=com.mantruckandbus.driver'
        target={'_blank'}
        bsStyle={Button.DEFAULT}
        className='margin-right-10'
        iconName='download'
        rel='noreferrer'
    >
        <FormattedMessage id='intl-msg:startpage.driverAppLink.buttonPlayStore' />
    </Button>
);

export const renderViewOnAppStoreButton = locale => {
    const language = (locale.split('-')[1] || 'gb').toLowerCase();
    const link = `https://apps.apple.com/${language}/app/man-driver/id1450811617`;

    return (
        <Button
            as='a'
            href={link}
            target={'_blank'}
            bsStyle={Button.DEFAULT}
            className='margin-right-10'
            iconName='download'
            rel='noreferrer'
        >
            <FormattedMessage id='intl-msg:startpage.driverAppLink.buttonAppStore' />
        </Button>
    );
};

export const renderOpenAdministrationButton = () => (
    <Button as='a' href='https://users.iam.rio.cloud' bsStyle={Button.DEFAULT} iconName='user-add'>
        <FormattedMessage id='intl-msg:startpage.driverInvitationRIO.buttonOpenAdministration' />
    </Button>
);

export const StartPageComponentWithoutInjection = ({ intl: { locale }, hasPDCReports }) => (
    <div className='StartPage'>
        {hasPDCReports && (
            <div className='StartPage-back'>
                <Button
                    as='a'
                    href='#/table'
                    bsStyle={Button.PRIMARY}
                    variant={Button.VARIANT_LINK}
                    iconName='icon-chevron-left'
                >
                    <FormattedMessage id='intl-msg:startpage.buttonBackToTableView' />
                </Button>
            </div>
        )}
        <StartTopPanel />
        <div className='StartPage-content'>
            <div className='display-grid grid-cols-2-sm column-gap-25 row-gap-25'>
                <StartPanelCard
                    illustrationName='communication/mobile-phone'
                    headline={<FormattedMessage id='intl-msg:startpage.driverAppLink.title' />}
                    text={<FormattedMessage id='intl-msg:startpage.driverAppLink.text' />}
                    buttons={[renderViewOnAppStoreButton(locale), renderViewOnPlayStoreButton()]}
                />

                <StartPanelCard
                    illustrationName='basic-interface/user'
                    headline={<FormattedMessage id='intl-msg:startpage.driverInvitationRIO.title' />}
                    text={<FormattedMessage id='intl-msg:startpage.driverInvitationRIO.text' />}
                    buttons={[renderOpenAdministrationButton()]}
                />
            </div>
        </div>
    </div>
);

StartPageComponentWithoutInjection.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
        locale: PropTypes.any,
    }).isRequired,
    hasPDCReports: PropTypes.any,
};

const StartPageComponent = props => {
    const hasPDCReports = useSelector(hasInspections);

    return <StartPageComponentWithoutInjection {...props} hasPDCReports={hasPDCReports} />;
};

export default injectIntl(StartPageComponent);
